import React from 'react';
import { useNavigate} from 'react-router-dom';

function NoMatch() {
    const navigate = useNavigate();
    
    React.useEffect(() => {
        navigate('/dealerOn');

        // unmount
        return () => {
        };
    }, [navigate]);
    
    return (<></>);
}

export default NoMatch;